import { CompatibilityService } from "../services/compatibilityservice";
import { TRouteInstanceSource } from '@common/rwf/routeinstancemodel';
import { IDialogState } from '@common/services/DialogService';

/** Description of the Concrete LoginOperation */
export type LoginOperation<TLoginResult> = (info: { Username: string, Password: string }) => PromiseLike<TLoginResult>;

export type ValidateCompanyConfig = { Company: string, StoreAsDefault: boolean };
/** Company Validation Function */
export type ValidateCompany = (config: ValidateCompanyConfig) => any | PromiseLike<any>;

/** connector to RWf Functionality needing userinteraction */
export class RwfUserInteraction {
    constructor(protected readonly $c: CompatibilityService) {

    }

    ModalLogin<TLoginResult>(operation: LoginOperation<TLoginResult>): PromiseLike<TLoginResult> {
        return this.$c.reject("Benutzerinteraktion für Anmeldung ist erforderlich!");
    }

    ModalSelectCompany(Companies: string[] | PromiseLike<string[]>, validate?: ValidateCompany): PromiseLike<string> {
        return this.$c.reject("Benutzerinteraktion für Auswahl eines Mandanten ist erforderlich!");
    }

    EditWorkflowInstance(context: CompatibilityService | Element, evt: Event | kendo.Observable, readOnly: boolean) {
        throw new Error("Benutzerinteraktion für Berbeiten eines Beleges erforderlich");
    }

    ModalMassRouteInstances(myInvoices: TRouteInstanceSource[], navUrl: string): PromiseLike<IDialogState> {
        throw new Error("Benutzerinteraktion für Massenweiterleitung erforderlich");
    }

}
